import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

export const CURRENT_TERMS_VERSION = 2;

interface AcknowledgementDialogProps {
  open: boolean;
  onAcknowledge: () => void;
}

const AcknowledgementDialog: React.FC<AcknowledgementDialogProps> = ({
  open,
  onAcknowledge
}) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <FormattedMessage
          id="terms_dialog_title"
          defaultMessage="Welcome to inesco energy"
        />
      </DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="terms_data_heading"
              defaultMessage="Your Data"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="terms_data_body"
              defaultMessage="Your installation data is securely stored in Switzerland. We do not share your data with third parties."
            />
          </Typography>
        </Box>

        <Divider />

        <Box my={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="terms_ai_heading"
              defaultMessage="AI-Powered Insights"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="terms_ai_body"
              defaultMessage="We use an AI service hosted in the EU to provide diagnostics and insights for your installations. AI-generated results are recommendations and should be verified by qualified personnel."
            />
          </Typography>
        </Box>

        <Divider />

        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            <FormattedMessage
              id="terms_cookies_heading"
              defaultMessage="Browser Storage"
            />
          </Typography>
          <Typography variant="body2">
            <FormattedMessage
              id="terms_cookies_body"
              defaultMessage="This platform stores login and preference settings in your browser to keep you signed in and remember your language choice."
            />
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onAcknowledge}>
          <FormattedMessage
            id="terms_acknowledge_button"
            defaultMessage="I understand"
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcknowledgementDialog;
